"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonp = exports.HttpH5 = void 0;
var shared_base_1 = require("@uip-alpha/shared-base");
var axios_1 = require("axios");
/*
 * 注入自定义拦截
 * 修改Method变小写
 */
var initAxios = function (config) {
    if (config.method)
        config.method = config.method.toLowerCase();
    if (config.method === 'post') {
        // 针对post请求将params属性转入data属性的处理
        // 加入针对原型属性的拷贝（from表单提交方式时会写入__proto__）
        if (config.params) {
            config.data = __assign({}, config.params);
            config.data.__proto__ = config.params.__proto__;
            delete config.params;
        }
        // 处理同时附带data和params的post请求
        if (config.postParams)
            config.params = config.postParams;
    }
    config.timeout = config.timeout || 60000;
    // 原本是直接return axios(config)，但如果外部项目也引用了axios，UIP和外部项目会公用同一个axios。为避免两者互相影响，UIP里面构造一个新的axios实例使用
    return axios_1.default.create()(config);
};
exports.HttpH5 = new shared_base_1.HttpBase(initAxios);
/** 用于记录其方法名 */
var count = 0;
/** jsonp重复请求缓存列表 */
var jsonpList = {};
/**
 *
 * @param config 各平台统一入参
 */
function jsonp(config) {
    var opts = __assign({ timeout: config.timeout || 60000 }, config.opts);
    var script = document.createElement('script');
    /** 由于symbol会需要sdk和客户端均有babel解析能力才能兼容，所以改为正常字符串
     * jsonp接收的name值为value，即回调函数名
     */
    var symbol = opts.name || "_jsonp_foo_" + count++;
    if (jsonpList[symbol])
        return jsonpList[symbol];
    var timer;
    function cleanup() {
        if (script.parentNode)
            document.body.removeChild(script);
        window[symbol] = undefined;
        clearTimeout(timer);
    }
    var params = config.params, url = config.url, fn = config.fn;
    var arrs = [];
    if (params)
        for (var key in params)
            arrs.push(key + "=" + params[key]);
    opts.callbackName && arrs.push(opts.callbackName + "=" + symbol);
    // 处理url本身含有参数的情况下？的兼容
    url = "" + (url.indexOf('?') > -1 ? url : url + '?') + arrs.join('&');
    jsonpList[symbol] = new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
            cleanup();
            var error = new Error('timeout');
            fn && fn(error);
            reject(error);
            delete jsonpList[symbol];
        }, opts.timeout);
        window[symbol] = function (data) {
            /** 超时情况 */
            fn && fn(data);
            resolve(data);
            delete jsonpList[symbol];
            cleanup();
        };
        script.src = url;
        document.body.appendChild(script);
    });
    return jsonpList[symbol];
}
exports.jsonp = jsonp;
var httpH5 = {
    name: 'httpH5',
    install: function (UIP) {
        /**
         * 覆盖默认的jsonp方法
         */
        UIP.http = exports.HttpH5;
        UIP.http.jsonp = jsonp;
    }
};
exports.default = httpH5;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@uip-alpha/http-h5/dist/index.js
// module id = 4MfF
// module chunks = 1